import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbao2user'

export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}

// /shenbao2user/{shenbaoId}/getUsersWithInfoByShenbao
export const getUserList = (shenbaoId, page, limit,params) => {
    return request(`${urlPrefix}/${shenbaoId}/getUsersWithInfoByShenbao`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

